module.exports = __webpack_public_path__ + "img/bsc_00.f179e0d5.png";